jQuery(function () {
    var cookieName = 'hide-testAccount-teaser';
    var hideTeaser = readCookie(cookieName);
    if (hideTeaser === 'true') {
        $('.test-account-puff').addClass('hidden');
    }
    else {
        $('.test-account-puff').removeClass('hidden');
    }
    $('.ts-test-account-puff__link').on('click', function () {
        var readMoreBtn = $(this);
        var readMoreText = $('.test-account-puff__content-bottom');
        readMoreBtn.fadeOut('fast', function () {
            readMoreText.slideDown();
        });
    });
    $('.ts-test-account-puff__close-btn').on('click', function () {
        $('.test-account-puff').addClass('hidden');
        document.cookie = cookieName + '=true';
    });
    function readCookie(name) {
        var nameEq = encodeURIComponent(name) + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEq) === 0) {
                return decodeURIComponent(c.substring(nameEq.length, c.length));
            }
        }
        return null;
    }
});
